import {Component, Input, OnInit} from '@angular/core';
import {UsanaObject} from "../../usana-object";
import {LoggerService} from "../../common/logger.service";
import {IMPGallerySubItemModule} from "../marketing-page.models";
import {MarketingPageUtil} from "../marketing-page-util";
import {ICartImage} from "../../cart/catalog/catalog-models";
import {CartUtil} from "../../cart/cart-util";
import {Constants} from "../../constants";

@Component({
    selector: 'gallery-sub-item',
    templateUrl: './gallery-sub-item.component.html',
    styleUrls: ['./gallery-sub-item.component.scss'],
    standalone: false
})
export class GallerySubItemComponent extends UsanaObject implements OnInit {

    @Input() componentData: IMPGallerySubItemModule;
    @Input() parentCardName: string;
    @Input() pageUrl: string;
    @Input() useLocaleOverride: boolean;

    translationRoot: string;
    iconImagePath: string;
    callToActionUrl: string;

    constructor(loggerService: LoggerService) {
        super(
            loggerService
        );
    }

    ngOnInit(): void {
        const combinedNames = this.parentCardName + '.' + this.componentData.name;
        this.translationRoot = MarketingPageUtil.getTranslationRoot(this.pageUrl, combinedNames);
        const cartImages: ICartImage[] = MarketingPageUtil.getCartImagesFromModule(this.componentData);
        this.iconImagePath = CartUtil.getCartImagePathByType(cartImages, Constants.IMAGE_TYPE_ICON);
        if(this.componentData.countryDetails?.length > 0) {
            this.callToActionUrl = this.componentData.countryDetails[0].callToActionUrl;
        }
    }

}
